import { Collapse } from "@mui/material";
import React, { useEffect } from "react";
import { CreatorThemeContext } from "../../../../../features/Common/modules/Theme/CreatorThemeContext";
import { DEFAULT_CREATOR_THEME } from "../../../../../features/Common/modules/Theme/constants/Theme.constants";
import { classNames } from "../../../../../utils/common/styling";
import Button from "../../../../common/Button/Button";
import CommentWithReplies from "../CommentWithReplies/CommentWithReplies";
import { getThemedStyles, styles } from "./CommentSection.styles";
import { ICommentSectionProps } from "./CommentSection.types";
import { HighlightedCommentWrapper } from "./modules/HighlightedCommentWrapper/HighlightedCommentWrapper";

/**
 * TODO - Creation of a Context State instead Props drilled to child Commonents.
 * CommentSectionContext
 */
const CommentSection = ({
  classes = {},
  creatorTheme,
  userImgSrc,
  commentsList,
  totalComments,
  showLoadMoreCommentsBtn,
  showHighlightedComment = false,
  showHighlightedReply = false,
  highlightSourceComment,
  loadHighlightedReply,
  highlightedComment,
  highlightedReply,
  setHighlightedReply,
  userUuid,
  isCreator,
  creatorUuid,
  loggedInUserFullName,
  userAvatarPreference,
  showCommentsTitle = true,
  CommentEditor,
  cdnBaseUrl,
  fetchCdnAsset,
  enableHideUnhideComment = false,
  loadComments,
  onCommentSectionFirstLoadSuccess,
  onCommentLikeClick,
  callGetCommentLikedByMembersListApi,
  onCommentUpdate,
  onCommentDelete,
  callSubmitCommentReplyApi,
  callGetCommentRepliesApi,
  callLikeCommentReplyApi,
  callEditCommentReplyApi,
  callDeleteCommentReplyApi,
  notifySuccess,
  notifyError,
  onMemberClick,
  canReport,
  onReport,
  showReported,
  highlightedReplyExpanded,
}: ICommentSectionProps) => {
  const themedStyles = getThemedStyles({
    theme: creatorTheme || DEFAULT_CREATOR_THEME,
  });

  const commentWithRepliesCommonProps = {
    loggedInUserFullName,
    userImgSrc,
    onCommentLikeClick,
    callGetCommentLikedByMembersListApi,
    userUuid,
    isCreator,
    creatorUuid,
    cdnBaseUrl,
    enableHideUnhideComment,
    fetchCdnAsset,
    userAvatarPreference,
    CommentEditor,
    onCommentUpdate,
    onCommentDelete,
    callSubmitReplyApi: callSubmitCommentReplyApi,
    callGetCommentRepliesApi,
    callLikeReplyApi: callLikeCommentReplyApi,
    callEditReplyApi: callEditCommentReplyApi,
    callDeleteReplyApi: callDeleteCommentReplyApi,
    notifySuccess,
    notifyError,
    onMemberClick,
  };

  useEffect(() => {
    loadComments({ successCallback: onCommentSectionFirstLoadSuccess });
  }, []);

  if (!totalComments) return null;

  return (
    <CreatorThemeContext.Provider value={creatorTheme || DEFAULT_CREATOR_THEME}>
      <div className={classNames(styles.container, classes.container)}>
        {showCommentsTitle && (
          <div className={styles.commentsTitle}>Comments</div>
        )}
        <Collapse in={true} classes={{ wrapperInner: styles.commentsList }}>
          {showHighlightedComment && highlightedComment && (
            <CommentWithReplies
              key={highlightedComment.uuid}
              showHighlightedReply={showHighlightedReply}
              loadHighlightedReply={loadHighlightedReply}
              highlightedReply={highlightedReply}
              data={highlightedComment}
              setHighlightedReply={setHighlightedReply}
              canReport={canReport}
              onReport={onReport}
              showReported={showReported}
              highlightedReplyExpanded={highlightedReplyExpanded}
              CommentWrapper={
                highlightSourceComment ? HighlightedCommentWrapper : undefined
              }
              {...commentWithRepliesCommonProps}
            />
          )}
          {(showHighlightedComment
            ? commentsList.filter(
                (comment) => comment.uuid !== highlightedComment?.uuid,
              )
            : commentsList
          ).map((i) => (
            <CommentWithReplies
              key={i.uuid}
              data={i}
              showHighlightedReply={false}
              canReport={canReport}
              onReport={onReport}
              showReported={showReported}
              {...commentWithRepliesCommonProps}
            />
          ))}
        </Collapse>
        {showLoadMoreCommentsBtn ? (
          <Button
            className={classNames(
              styles.loadMoreCommentsBtn,
              themedStyles.loadMoreCommentsBtn,
            )}
            onClick={() => loadComments()}
            color="unset"
            size="unset"
          >
            Load more comments
          </Button>
        ) : null}
      </div>
    </CreatorThemeContext.Provider>
  );
};

export default CommentSection;
